import api from "../../api";

class ClientPrice {
  index() {
   return api.get('prices');
  }

  store(data) {
    return api.post('prices', data);
  }

  show(id) {
    return api.get(`prices/${id}`);
  }

  update(id, data) {
    return api.put(`prices/${id}`, data);
  }

  destroy(service_id, group_enterprises_id, date_start) {
    return api.delete(`prices/${service_id}/${group_enterprises_id}/${date_start}`);
  }

  search(id) {
    return api.get(`prices/service/search/${id}`);
  }
}

export default new ClientPrice();
